module.exports = __webpack_public_path__ + "static/img/6.90ea4a5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/1/eng/6.png
// module id = bLvy
// module chunks = 0